import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Register from '@/components/Register'
import RegisterBP from '@/components/RegisterBP'
import RegisterNewCar from '@/components/RegisterNewCar'
import RegisterInsurrance from '@/components/RegisterInsurrance'
import Confirm from '@/components/Confirm'
import ConfirmBP from '@/components/ConfirmBP'
import ConfirmNewCar from '@/components/ConfirmNewCar'
import ConfirmInsurance from '@/components/ConfirmInsurance'
import QRCode from '@/components/QRCode'
import QRCodeBP from '@/components/QRCodeBP'
import QRCodeNewCar from '@/components/QRCodeNewCar'
import QRCodeInsurance from '@/components/QRCodeInsurance'
import Progress from '@/components/Progress'
import Workshop from '@/components/Workshop'
import WorkshopBP from '@/components/WorkshopBP'
import Manage from '@/components/Manage'
import User from '@/components/User'
import insurance from '@/components/insurance'
import UpdateInsurance from '@/components/UpdateInsurance'
import bpEstimate from '@/components/BP/estimate'
import bpWorkshop from '@/components/BP/workshop'
import bpClosejob from '@/components/BP/closejob'
import bpChange from '@/components/BP/change'
// import BoardControl from '@/components/BoardControl'
import Search from '@/components/Search'
import SearchByLine from '@/components/SearchByLine'
import SearchByFrame from '@/components/SearchByFrame'
import Rating from '@/components/Rating'
import RatingReport from '@/components/RatingReport'
import History from '@/components/History'
import Booking from '@/components/Booking'
import DropAndGoManage from '@/components/DropAndGo/manage'
import DropAndGoDocument from '@/components/DropAndgo/document'
import Followup from '@/components/Followup'
import FollowupBP from '@/components/FollowupBP'
import Location from '@/components/Location'
import Export from '@/components/Export'
import FRTControl from '@/components/FRT/control'
import PDPA from '@/components/pdpa'
import VueSession from 'vue-session'

var options = {
  persist: true
}

Vue.use(VueSession, options)
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/pdpa',
      name: 'PDPA',
      component: PDPA
    },
    {
      path: '/search',
      name: 'Search',
      component: Search
    },
    {
      path: '/searchUser',
      name: 'SearchUser',
      component: SearchByLine
    },
    {
      path: '/searchFrame',
      name: 'SearchFrame',
      component: SearchByFrame
    },
    {
      path: '/bp/workshop',
      name: 'BP_Workshop',
      component: bpWorkshop
    },
    {
      path: '/bp/estimate',
      name: 'BP_Estimate',
      component: bpEstimate
    },
    {
      path: '/bp/closejob',
      name: 'BP_Closejob',
      component: bpClosejob
    },
    {
      path: '/bp/change',
      name: 'BP_Change',
      component: bpChange
    },
    {
      path: '/frt/control',
      name: 'FRTControl',
      component: FRTControl
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/registerBP',
      name: 'RegisterBP',
      component: RegisterBP
    },
    {
      path: '/registerNewCar',
      name: 'RegisterNewCar',
      component: RegisterNewCar
    },
    {
      path: '/RegisterInsurance',
      name: 'RegisterInsurance',
      component: RegisterInsurrance
    },
    {
      path: '/confirm',
      name: 'Confirm',
      component: Confirm
    },
    {
      path: '/confirm_bp',
      name: 'ConfirmBP',
      component: ConfirmBP
    },
    {
      path: '/confirmNewCar',
      name: 'ConfirmNewCar',
      component: ConfirmNewCar
    },
    {
      path: '/confirmInsurance',
      name: 'ConfirmInsurance',
      component: ConfirmInsurance
    },
    {
      path: '/qrcode',
      name: 'QRCode',
      component: QRCode
    },
    {
      path: '/qrcode_bp',
      name: 'QRCodeBP',
      component: QRCodeBP
    },
    {
      path: '/qrcode_new',
      name: 'QRCodeNew',
      component: QRCode
    },
    {
      path: '/qrcodeNewCar',
      name: 'QRCodeNewCar',
      component: QRCodeNewCar
    },
    {
      path: '/qrcodeInsurance',
      name: 'QRCodeInsurance',
      component: QRCodeInsurance
    },
    {
      path: '/progress',
      name: 'Progress',
      component: Progress
    },
    {
      path: '/workshop',
      name: 'Workshop',
      component: Workshop
    },
    {
      path: '/workshopBP',
      name: 'WorkshopBP',
      component: WorkshopBP
    },
    {
      path: '/manage',
      name: 'Manage',
      component: Manage
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    // {
    //   path: '/boardcontrol',
    //   name: 'BoardControl',
    //   component: BoardControl
    // },
    {
      path: '/rating',
      name: 'Rating',
      component: Rating
    },
    {
      path: '/rating_report',
      name: 'RatingReport',
      component: RatingReport
    },
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/dropandgo/manage',
      name: 'DropAndGoManage',
      component: DropAndGoManage
    },
    {
      path: '/dropandgo/document',
      name: 'DropAndGoDocument',
      component: DropAndGoDocument
    },
    {
      path: '/booking',
      name: 'Booking',
      component: Booking
    },
    {
      path: '/appointment',
      name: 'Appointment',
      component: Booking
    },
    {
      path: '/followup',
      name: 'Followup',
      component: Followup
    },
    {
      path: '/followupBP',
      name: 'FollowupBP',
      component: FollowupBP
    },
    {
      path: '/location',
      name: 'Location',
      component: Location
    },
    {
      path: '/export',
      name: 'Export',
      component: Export
    },
    {
      path: '/insurance',
      name: 'Insurance',
      component: insurance
    },
    {
      path: '/UpdateInsurance',
      name: 'UpdateInsurance',
      component: UpdateInsurance
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js